import type { MediaPlanFormValues } from './schemas';
import type { Area, PriorityGroup } from '../offlineSalesOptimizer/types';
import type { AudienceLibrary } from '@/features/audienceLibrary';

export type MediaPlan = MediaPlanFormValues & {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
};

type WithAudienceLibraryDetail<T> = T extends infer U
  ? Omit<U, 'audienceLibrary'> & {
      audienceLibrary: AudienceLibrary | null;
      associatedCampaignsCount: number;
    }
  : T;

export type MediaPlanDetail = WithAudienceLibraryDetail<MediaPlan>;

export type MediaPlanListItem = Omit<
  MediaPlanDetail,
  'advertiserName' | 'accountName'
> & {
  advertiser: string;
  account: string;
};

export type ExperimentFailureReason = 'budget' | 'flight' | 'budget_and_flight';

export enum ExperimentStatus {
  Pending = 'PENDING',
  Active = 'ACTIVE',
  Rejected = 'REJECTED',
}

export interface Experiment {
  status: ExperimentStatus | null;
  approvalDate: string | null;
  directionalReadoutDate: string | null;
  rejectionMessage: ExperimentFailureReason | null;
}

export type StrategyComparisonParams = { id: number } & Pick<
  MediaPlanFormValues,
  'dataMode' | 'secondaryGoal'
>;

interface StrategyComparisonOneSideResponse {
  dataMode: MediaPlanFormValues['dataMode'];
  secondaryGoal: MediaPlanFormValues['secondaryGoal'];
  effectivenessIndex: {
    l: number;
    m: number;
    h: number;
  };
  precisionAreas: {
    areasByPriority: Record<PriorityGroup, Area[]>;
  };
  heatMap: {
    areaId: string;
    areaName: string;
    bucket: PriorityGroup | null;
    populationSize: number;
  }[];
}
export interface StrategyComparisonResponse {
  brand: string;
  country: string;
  leftSide: StrategyComparisonOneSideResponse;
  rightSide: StrategyComparisonOneSideResponse;
}
